<template>
  <select class="m-r-xs">
    <slot></slot>
    <option
      v-for="option in options"
      :value="option.id"
      :key="option.id"
      :disabled="disabledValues.includes(option.id)"
      :selected="option.id==value"
    >{{option.name}}</option>
  </select>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      default: function () {
        return []
      },
    },
    disabledValues: {
      type: Array,
      default: function () {
        return []
      },
    },
    value: {
      type: [String, Number],
    },
    hideSearchBox: {
      type: Boolean,
      default: false,
    },
  },
  mounted: function () {
    this.initSelect2()
  },
  watch: {
    value: function (value) {
      // update value
      $(this.$el).val(value).trigger('change')
    },
  },
  destroyed: function () {
    $(this.$el).off().select2('destroy')
  },
  methods: {
    initSelect2() {
      let vm = this
      let options = {
        containerCssClass: 'labeled',
        escapeMarkup: function (markup) {
          return markup
        },
      }
      if (this.hideSearchBox) options.minimumResultsForSearch = -1
      $(this.$el)
        // init select2
        .select2(options)
        .val(this.value)
        .trigger('change')
        // emit event on change.
        .on('change', function () {
          vm.$emit('input', this.value)
        })
    },
  },
}
</script>